export function getCookie(name) { //获取cookie
	var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	if(arr = document.cookie.match(reg)) {
		var data = unescape(arr[2]);
		return data;
	} else {
		return '';
	}
}
export function delCookie(name) { //删除cookie
	var exp = new Date();
	exp.setTime(exp.getTime() - 1);
	var cval = this.getCookie(name);
	console.log(this.getCookie(name))
	document.cookie = name + "=" + cval + ";path=/;domain=reflower.com.cn;expires=" + exp.toGMTString() + "";
}
export function setCookie(name, value) { //添加cookie
	var Days = 1;
	var exp = new Date();
	exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
	var cookie = name + "=" + escape(value) + ";path=/;domain=reflower.com.cn;expires=" + exp.toGMTString() + "";
	document.cookie = cookie;
//		console.log(document.cookie)

}


// WEBPACK FOOTER //
// ./src/utils/cookie.js